/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsExchange = createReactComponent("arrows-exchange", "IconArrowsExchange", [
  ["path", { d: "M7 10h14l-4 -4", key: "svg-0" }],
  ["path", { d: "M17 14h-14l4 4", key: "svg-1" }]
]);

export { IconArrowsExchange as default };
//# sourceMappingURL=IconArrowsExchange.js.map
